import NodeCategories, { EDataType } from '../models/node-data';
import NodeList from './MenuNodeList';

export default function MenuDevices() {
  const filter = Object.keys(NodeCategories).filter(
    (key) =>
      NodeCategories[key as keyof typeof NodeCategories].type ===
      EDataType.Device,
  );

  return <NodeList data={filter} />;
}
